// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--dark.v-tabs-items[data-v-389b0d50],.theme--light.v-tabs-items[data-v-389b0d50]{background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
